package com.nonopn.skydome.common.app.pages.main.model.api

import com.nonopn.skydome.common.app.api.model.DashboardImpactReportV2
import com.nonopn.skywatcher.maps.LatLng
import kotlinx.serialization.Serializable

@Serializable
data class ApiAnswer(
    val probes: List<Probe>,
    val projects: List<Project>,
    val impacts: List<ThunderDetectionActivity>,
    val aeroguardPoints: List<AeroguardLocation>? = null
)

@Serializable
data class ApiEstimatesData(
    val project: Project,
    val topActivities: List<SectionProjectAndThunderDetection.Top>,
    val intensityReports1km: DashboardImpactReportV2.MathReport? = null,
    val intensityReports2km: DashboardImpactReportV2.MathReport? = null,
    val cardinal1km: Int = 0,
    val cardinal2km: Int = 0,
)

@Serializable
data class AeroguardLocation(
    val uuid: String,
    val position: LatLng
)
